import { render, staticRenderFns } from "./RecurringViberCampaignEditRoute.vue?vue&type=template&id=51d85033&scoped=true&"
import script from "./RecurringViberCampaignEditRoute.vue?vue&type=script&lang=js&"
export * from "./RecurringViberCampaignEditRoute.vue?vue&type=script&lang=js&"
import style0 from "./RecurringViberCampaignEditRoute.vue?vue&type=style&index=0&id=51d85033&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d85033",
  null
  
)

export default component.exports